import { useEffect, useState } from "react";
import { getRandomUUID } from "../../Token";
import { useSelector } from "react-redux";

const useFetch = (url, init, deps = [], setParentloading = () => {}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(true);
  const [error, seterror] = useState("");

  useEffect(() => {
    let mounted = false;
    if (!mounted) {
      const fetchData = async () => {
        setParentloading(true);
        try {
          const response = await fetch(url, {
            headers: {
              "Content-Type": "application/json",
              ...(activeSession.sessionToken && { Authorization: `Bearer ${activeSession.sessionToken}` }),
              "VZ-M2M-Token": getRandomUUID(),
            },
            method: init?.method || "GET",
            ...init,
          });
          const respdata = await response.json();
          setdata(respdata);
          setloading(false);
          setParentloading(false);
        } catch (error) {
          seterror(error);
          setloading(false);
          setParentloading(false);
        }
      };
      fetchData();
    }
    return () => (mounted = true);
  }, [...deps]);
  console.log("Fetching data...", data, loading, error);

  return { data, loading, error };
};

export default useFetch;
